<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/>

    <p v-for="(message, index) in messages" :key="index">
      {{message}}
    </p>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

import Vue from 'vue'
import {db} from '@/firebaseConfig.js'
// const fb = require('../firebaseConfig.js')

export default {
  name: 'Home',
  components: {
    HelloWorld
  },
  data() {
    return {
      messages: {}
    }
  },
  created() {
    db.collection('messages')
    .where("status", "==", "active")
    .onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if (change.type == 'added') {
            Vue.set(this.messages, change.doc.id, change.doc.data());
          } else if (change.type == 'modified') {
            this.messages[change.doc.id] = change.doc.data();
          } else if (change.type == 'removed') {
            Vue.delete(this.messages, change.doc.id);
          }
        });
    });
  }
}
</script>
